export default "__VITE_ASSET__xl82MY01__"